import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMenuOrderCreate = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			opacity: .4,
			d: "M2.77 10C2.34 10 2 9.66 2 9.23V6.92C2 4.21 4.21 2 6.92 2H9.23C9.66 2 10 2.34 10 2.77C10 3.2 9.66 3.54 9.23 3.54H6.92C5.05 3.54 3.54 5.06 3.54 6.92V9.23C3.54 9.66 3.19 10 2.77 10Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .4,
			d: "M21.23 10C20.81 10 20.46 9.66 20.46 9.23V6.92C20.46 5.05 18.94 3.54 17.08 3.54H14.77C14.34 3.54 14 3.19 14 2.77C14 2.35 14.34 2 14.77 2H17.08C19.79 2 22 4.21 22 6.92V9.23C22 9.66 21.66 10 21.23 10Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.0799 22.0002H15.6899C15.2699 22.0002 14.9199 21.6602 14.9199 21.2302C14.9199 20.8102 15.2599 20.4602 15.6899 20.4602H17.0799C18.9499 20.4602 20.4599 18.9402 20.4599 17.0802V15.7002C20.4599 15.2802 20.7999 14.9302 21.2299 14.9302C21.6499 14.9302 21.9999 15.2702 21.9999 15.7002V17.0802C21.9999 19.7902 19.7899 22.0002 17.0799 22.0002Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.23 22H6.92C4.21 22 2 19.79 2 17.08V14.77C2 14.34 2.34 14 2.77 14C3.2 14 3.54 14.34 3.54 14.77V17.08C3.54 18.95 5.06 20.46 6.92 20.46H9.23C9.65 20.46 10 20.8 10 21.23C10 21.66 9.66 22 9.23 22Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.4595 11.23H17.0995H6.89953H5.53953C5.10953 11.23 4.76953 11.58 4.76953 12C4.76953 12.42 5.10953 12.77 5.53953 12.77H6.89953H17.0995H18.4595C18.8895 12.77 19.2295 12.42 19.2295 12C19.2295 11.58 18.8895 11.23 18.4595 11.23Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.90039 13.94V14.27C6.90039 15.93 8.24039 17.27 9.90039 17.27H14.1004C15.7604 17.27 17.1004 15.93 17.1004 14.27V13.94C17.1004 13.82 17.0104 13.73 16.8904 13.73H7.11039C6.99039 13.73 6.90039 13.82 6.90039 13.94Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .4,
			d: "M6.90039 10.06V9.72998C6.90039 8.06998 8.24039 6.72998 9.90039 6.72998H14.1004C15.7604 6.72998 17.1004 8.06998 17.1004 9.72998V10.06C17.1004 10.18 17.0104 10.27 16.8904 10.27H7.11039C6.99039 10.27 6.90039 10.18 6.90039 10.06Z",
			fill: "#FFFFFF"
		})
	]
});
export default SvgMenuOrderCreate;
